export class TableState {
  pageIndex: number;
  pageSize: number;
  sortColumn: string;
  sortDirection: string;
  scrollPosition: [number, number];

  public static initialState(sortColumn: string): TableState {
    return {
      pageIndex: 0,
      pageSize: 25,
      sortColumn: sortColumn,
      sortDirection: 'asc',
      scrollPosition: [0, 0]
    };
  }
}
